<template>
	<file-upload
		end-point="/api/v0/adyensettlementreportfiles"
		upload-name="settlement_report"
		:inputs="['settlement report']"
	/>
</template>

<script>

export default {
	name: 'SettlementReportUpload',

};
</script>
